var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{staticClass:"brand-logo"},[_c('logo',{attrs:{"width":240,"height":72,"isWhite":_vm.isWhite}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }